import * as React from 'react';
var HeaderNavigationMenuContentContext = React.createContext({
  isExpanded: undefined,
  setIsExpanded: undefined
});
export default HeaderNavigationMenuContentContext;